var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lbv-update-parameters animated fadeIn roundedCard" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-12" },
          [
            _vm.$store.getters.roleID === "4"
              ? _c("b-card", [
                  _c("h1", { staticClass: "lbv-page-title updateParameters" }, [
                    _vm._v("\n          Update Parameters\n        "),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "updateParametersInputs" }, [
                    _c("p", [
                      _vm._v(
                        "This page is provided so that you can update the parameters of a single device. You can stack up as many as you like."
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Please remember - For SigFox devices they are only able to receive 4 parameters per day and these parameter will only be sent when the device sends an acknowledged message."
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.updateParam.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "2" } }, [
                              _c("label", [_vm._v("LeakBot ID:")]),
                            ]),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "10" } }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.leakBotID,
                                    expression: "leakBotID",
                                  },
                                ],
                                staticClass: "form-control full-width",
                                attrs: { type: "text" },
                                domProps: { value: _vm.leakBotID },
                                on: {
                                  change: _vm.populateParameter,
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.leakBotID = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "push-down" },
                          [
                            _c("b-col", { attrs: { cols: "2" } }, [
                              _c("label", [_vm._v("Logging (sigfox only):")]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "10" } },
                              [
                                _c(
                                  "b-form-select",
                                  {
                                    staticClass: "full-width",
                                    model: {
                                      value: _vm.loggingType,
                                      callback: function ($$v) {
                                        _vm.loggingType = $$v
                                      },
                                      expression: "loggingType",
                                    },
                                  },
                                  [
                                    _c("option", { domProps: { value: 3 } }, [
                                      _vm._v(
                                        "\n                    Leave Unchanged\n                  "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "1" } }, [
                                      _vm._v(
                                        "\n                    Turn Off\n                  "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "2" } }, [
                                      _vm._v(
                                        "\n                    Turn On\n                  "
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "push-down" },
                          [
                            _c("b-col", { attrs: { cols: "2" } }, [
                              _c("label", [_vm._v("Parameter:")]),
                            ]),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "10" } }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.parameterSelector,
                                      expression: "parameterSelector",
                                    },
                                  ],
                                  staticClass: "form-control full-width",
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.parameterSelector = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                      _vm.updateLegend,
                                    ],
                                  },
                                },
                                [
                                  _vm.parameterList !== null
                                    ? _c(
                                        "option",
                                        {
                                          attrs: { disabled: "" },
                                          domProps: { value: null },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Please select an option\n                  "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.parameterList,
                                    function (parameter) {
                                      return _c(
                                        "option",
                                        {
                                          domProps: {
                                            value: {
                                              id: parameter.parameterNumber,
                                              name: parameter.parameterName,
                                              minVal: parameter.minVal,
                                              maxVal: parameter.maxVal,
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                parameter.parameterNumber
                                              ) +
                                              " - " +
                                              _vm._s(parameter.parameterName) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "push-down" },
                          [
                            _c("b-col", { attrs: { cols: "2" } }, [
                              _c("label", [
                                _vm._v(
                                  "Parameter Value (" +
                                    _vm._s(_vm.parameterValueLabelMin) +
                                    " , " +
                                    _vm._s(_vm.parameterValueLabelMax) +
                                    "):"
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "10" } }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.parameterValue,
                                    expression: "parameterValue",
                                  },
                                ],
                                staticClass: "form-control full-width",
                                attrs: { type: "text" },
                                domProps: { value: _vm.parameterValue },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.parameterValue = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary parameterUpdate",
                            attrs: { type: "submit" },
                          },
                          [_c("span", [_vm._v("Queue Parameter Update")])]
                        ),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          staticClass: "reportErr",
          attrs: { show: _vm.errorString != "", variant: "danger" },
        },
        [_vm._v("\n    " + _vm._s(_vm.errorString) + "\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }